import { DEFAULT_DECIMALS, NativeTokens } from '@trinity/blockchain-common';
export const TokenDecimalsQuery = {
    queryKey: (token) => ['token-decimals', token],
    queryFn: async (blockchainService, token) => {
        if (token === NativeTokens.Main) {
            return DEFAULT_DECIMALS;
        }
        return await blockchainService.getTokenDecimals(token);
    },
};
//# sourceMappingURL=token-decimals.js.map